import { Col, Row, Space, Typography } from 'antd';
import { EMPTY } from 'views/customers/customer/utils';
import { getFormattedPhoneNumber } from 'utils/phoneNumber';
import { usePartyContext } from '../../../../PartyProvider';

const ContactDetailsView = () => {
    const { customer } = usePartyContext();

    const phoneNumber = getFormattedPhoneNumber(customer.contact.phoneNumber);

    return (
        <Space direction="vertical" size={12} style={{ width: '100%' }}>
            <Row>
                <Col sm={24} md={12}>
                    <Space direction="vertical" size={6}>
                        <Typography.Text>Contact Name</Typography.Text>
                        <Typography.Text style={{ fontWeight: 600 }}>{customer.contact.name ?? EMPTY}</Typography.Text>
                    </Space>
                </Col>
                <Col sm={24} md={12}>
                    <Space direction="vertical" size={6}>
                        <Typography.Text>Email Address</Typography.Text>
                        <Typography.Text style={{ fontWeight: 600 }}>{customer.contact.email ?? EMPTY}</Typography.Text>
                    </Space>
                </Col>
            </Row>

            <Row>
                <Col sm={24} md={12}>
                    <Space direction="vertical" size={6}>
                        <Typography.Text>Phone Number</Typography.Text>
                        <Typography.Text style={{ fontWeight: 600 }}>{phoneNumber ?? EMPTY}</Typography.Text>
                    </Space>
                </Col>
            </Row>
        </Space>
    );
};

export default ContactDetailsView;
